export const getUserType = user => {
    const userType = user?.attributes?.profile?.publicData?.userType;
    return userType;
  };
  
  export const isCurrentUserAdmin = user => {
    // The user should be the currentUser
    return (
      (user &&
        user?.attributes &&
        user.attributes.profile &&
        user.attributes.profile.protectedData &&
        user.attributes.profile.protectedData.isAdmin) ||
      false
    );
  };
  
  export const canUserResubmitApproval = user => {
    // Current User
    return (
      (user &&
        user?.attributes &&
        user.attributes.profile &&
        user.attributes.profile.protectedData &&
        user.attributes.profile.protectedData.isRejectedOne &&
        user.attributes.profile.protectedData.reApproval &&
        !user.attributes.profile.protectedData.reApprovalDescription) ||
      false
    );
  };
  export const isUserPendingApproval = user => {
    return (
      (user &&
        user?.attributes &&
        user.attributes.state === 'pendingApproval') ||
      false
    );
  };
  export const isPermanentRejected = user => {
    return (
      (user &&
        user?.attributes &&
        user.attributes.profile &&
        user.attributes.profile.protectedData &&
        user.attributes.profile.protectedData.isRejectedTwo) ||
      false
    );
  };
  
  export const getUserFirstAndLastName = user => {
    const firstName = user?.attributes?.profile?.firstName;
    const lastName = user?.attributes?.profile?.lastName;
    return { firstName, lastName };
  };
  

// Teaching Category Labels
export const EN_TEACHING_CATEGORY_LABELS = {
  arabicforkids: 'Arabic for Kids',
  modernstandardarabicmsa: 'Modern Standard Arabic (MSA)',
  arabicforschool: 'Arabic for School',
  arabicforwork: 'Arabic for Work',
  storiesandsongs: 'Stories & Songs',
  storiessongs: 'Stories & Songs',
  quranicarabic: 'Quranic Arabic',
  quranic: 'Quranic Arabic',
  arabicfromscratch: 'Arabic from Scratch',
  scratch: 'Arabic from Scratch',
};

export const AR_TEACHING_CATEGORY_LABELS = {
  arabicforkids: 'العربية للأطفال',
  modernstandardarabicmsa: 'العربية الفصحى الحديثة (MSA)',
  arabicforschool: 'العربية للمدرسة',
  arabicforwork: 'العربية للعمل',
  storiesandsongs: 'القصص والأناشيد',
  storiessongs: 'القصص والأناشيد',
  quranicarabic: 'القرآن الكريم واللغة العربية',
  quranic: 'القرآن الكريم واللغة العربية',
  arabicfromscratch: 'العربية من الصفر',
  scratch: 'العربية من الصفر',
};

// Helper function to normalize category keys for lookup
export const normalizeCategoryLookupKey = value =>
  String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

// Helper function to humanize category values
export const humanizeCategoryValue = value =>
  String(value || '')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, char => char.toUpperCase());
